/**
 * The app shell's horizontal lengths, each set once here, in rem (Estevan 10-17,
 * docs/decisions/ESTEVAN_rulings_2026-10-17_side_panel_widths.md).
 *
 * Widths. The sidebar is 18rem (288 px) and the Dashboard's right panel ("Files in this chat", Recent uploads)
 * 20rem (320 px), and the two read as one width: the panel's file cards make a column 288 px wide less its 1 px
 * border (20rem less its 1rem padding each side), while the sidebar's background fills its whole box. Estevan
 * set the sidebar to 288 px in the browser and it matched the panel; 320 px read wider. The panel keeps 20rem,
 * so its cards keep today's room (every date fits).
 *
 * Gutter. From lg the header sets the logo SHELL_GUTTER in from the window's left edge, and the sidebar's
 * section labels and nav icons sit on that same line; a row's active pill bleeds left of it by the row's own
 * padding. A phone keeps its own insets.
 */
import type React from 'react';

export const SIDEBAR_WIDTH_CLASS = 'w-[18rem]';
export const FILES_PANEL_WIDTH_CLASS = 'w-[20rem]';

export const SHELL_GUTTER = '2rem';
/** Sets `--shell-gutter`, which the header's and the sidebar's lg classes read. */
export const SHELL_GUTTER_STYLE = { '--shell-gutter': SHELL_GUTTER } as React.CSSProperties;
